<template>
  <div class="card">
    <div class="card-header" />
    <div class="card-body">
      <h4 class="card-title">Программа старта</h4>

      <b-form @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group />
          </b-col>

          <!-- Даты начала/конца регистрации -->
          <b-col md="6">
            <div class="links">
              <b-form-group class="time-pick">
                <span>Начало регистрации*</span>
                <flat-pickr
                  v-model="localStart.registration_start_date"
                  class="form-control"
                  :config="config"
                />
              </b-form-group>

              <b-form-group class="time-pick">
                <span>Конец регистрации*</span>
                <flat-pickr
                  v-model="localStart.registration_end_date"
                  class="form-control"
                  :config="config"
                />
              </b-form-group>
            </div>

            <b-col
              md="12"
              style="padding: 0"
            >
              <div class="links">
                <b-form-group class="time-pick">
                  <span>Начало старта*</span>
                  <flat-pickr
                    v-model="localStart.start_date"
                    class="form-control"
                    :config="config"
                  />
                </b-form-group>

                <b-form-group class="time-pick">
                  <span>Конец старта*</span>
                  <flat-pickr
                    v-model="localStart.end_date"
                    class="form-control"
                    :config="config"
                  />
                </b-form-group>
              </div>
            </b-col>
          </b-col>

          <!-- Переключатели -->
          <b-form-group>
            <b-col
              md="12"
              class="switches"
            >
              <div class="switch">
                <b-card-text class="mb-0">
                  Закрыть регистрацию на старт
                </b-card-text>
                <b-form-checkbox
                  v-model="localStart.isClosed"
                  switch
                  class="custom-control-primary"
                />
              </div>

              <div class="switch">
                <b-card-text class="mb-0"> Дата старта изменена </b-card-text>
                <b-form-checkbox
                  v-model="localStart.isRescheduled"
                  switch
                  class="custom-control-primary"
                />
              </div>

              <div class="switch">
                <b-card-text class="mb-0"> Регистрация на месте </b-card-text>
                <b-form-checkbox
                  v-model="localStart.registration_on_place"
                  switch
                  class="custom-control-primary"
                />
              </div>
            </b-col>
          </b-form-group>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BCardText,
  BRow,
  BCol,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  name: 'ProgramOfStartSection',

  components: {
    BForm,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BCardText,
    BRow,
    BCol,
    flatPickr,
  },

  props: {
    start: { type: Object, required: true },
    config: { type: Object, required: true },
  },

  computed: {
    localStart: {
      get() {
        return this.start
      },
      set(val) {
        this.$emit('update:start', val)
      },
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.links {
  display: flex;
  align-items: center;
}

.time-pick {
  margin-right: 15px;
}

.switches {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
